import React from 'react';
import MainContentContainer from '../../../../../v2BaseComponents/MainContentContainer';
import CareTeamMembersTable from './CareTeamMembersTable';
import { useIsMobileLayout } from '../../../../../../hooks/useIsMobileLayout';

export type CareTeamMembersTabOwnProps = {};

export type CareTeamMembersTabProps = CareTeamMembersTabOwnProps;

const CareTeamMembersTab: React.FC<CareTeamMembersTabProps> = () => {
    const isMobile = useIsMobileLayout();

    return (
        <MainContentContainer flex={1} style={isMobile ? {} : { paddingLeft: 0, paddingRight: 0 }}>
            <CareTeamMembersTable />
        </MainContentContainer>
    );
};

export default React.memo(CareTeamMembersTab);
